export function drawerWidth(isMobile, desktopPercent = 65) {
  return isMobile ? "100%" : `${desktopPercent}%`;
}

export function contentPadding(isMobile) {
  return isMobile ? 12 : 16;
}

export function listMinWidth(isMobile, desktopMin = 500) {
  return isMobile ? "0px" : `${desktopMin}px`;
}

export function cardMinWidth(isMobile, desktopMin = 450) {
  return isMobile ? 0 : desktopMin;
}
